<template>
  <div>

    <Header />
    
    <Navigation />

    <router-view />

    <Footer />

  </div>
</template>

<script>

import Header from '@/components/Header'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'

export default {
  components: {
      Header,
      Navigation,
      Footer
  }
}
</script>

<style lang="scss">
  //@import "@/assets/_variables.scss";
</style>
